import { Editor } from "@tinymce/tinymce-react";
import React from "react";
import { createRoot } from "react-dom/client";

class HtmlConverter {
  constructor() {
    // @ts-ignore
    this.editor = null;
    // @ts-ignore
    this.container = null;
    // @ts-ignore
    this.root = null;
    this.initializeEditor();
  }

  initializeEditor() {
    // @ts-ignore
    if (this.container) return;

    // @ts-ignore
    this.container = document.createElement("div");
    // @ts-ignore
    this.container.style.display = "none";
    // @ts-ignore
    document.body.appendChild(this.container);

    // @ts-ignore
    this.root = createRoot(this.container);

    // @ts-ignore
    this.root.render(
      <Editor
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => {
          // @ts-ignore
          this.editor = editor;
        }}
        init={{
          menubar: false,
          toolbar: false,
          statusbar: false,
          plugins: [],
          branding: false,
          elementpath: false,
          // @ts-ignore
          readonly: true,
          height: 0,
          convert_unsafe_embeds: true,
        }}
      />
    );
  }

  convertToPlainText(html: any) {
    // @ts-ignore
    if (!html || !this.editor) return "";

    // @ts-ignore
    this.editor.setContent(html);
    // @ts-ignore
    return this.editor.getContent({ format: "text" });
  }

  destroy() {
    // @ts-ignore
    if (this.root) {
      // @ts-ignore
      this.root.unmount();
      // @ts-ignore
      this.container.remove();
      // @ts-ignore
      this.root = null;
      // @ts-ignore
      this.container = null;
      // @ts-ignore
      this.editor = null;
    }
  }
}

export { HtmlConverter };
